var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleAuthenticatorIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7228 12.7866H11.1686L7.44053 6.32239C6.82963 5.26382 7.19196 3.90897 8.25051 3.29798C8.59861 3.09659 8.97885 3.00117 9.35434 3.00117C10.1185 3.00117 10.8621 3.39814 11.2718 4.10877L14.9999 10.572L13.7228 12.7866Z",
    fill: "#FCBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7501 26.7035C20.6926 27.315 19.3391 26.9518 18.7277 25.8927L14.9996 19.4295L11.2715 25.8927C10.6606 26.9513 9.3077 27.315 8.25021 26.7035C7.54082 26.2934 7.14374 25.549 7.14374 24.784C7.14374 24.4082 7.23906 24.0275 7.44024 23.678L11.1683 17.2148H18.832L22.5601 23.678C23.171 24.7377 22.8076 26.092 21.7501 26.7035Z",
    fill: "#E94335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4999 14.9999C28.4999 16.2229 27.5093 17.2146 26.2875 17.2146H18.8319L17.5543 14.9999L16.2777 12.7857L15.0001 10.5711L18.7281 4.1079C19.339 3.04827 20.6925 2.68557 21.7505 3.2971C22.808 3.9081 23.1714 5.26294 22.5605 6.32151L18.8319 12.7863H26.2875C27.5099 12.7863 28.4999 13.7774 28.4999 14.9999Z",
    fill: "#1973E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7228 12.7863L12.4452 15.0005L11.1686 17.2151H3.71189C2.49061 17.2151 1.5 16.2235 1.5 15.0005C1.5 14.3895 1.74699 13.8359 2.14777 13.4348C2.54854 13.0346 3.10046 12.7863 3.71189 12.7863H13.7228Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8311 17.215H11.168L12.4445 15.0003L13.7222 12.7867L14.9993 10.5715L16.2769 12.7867L17.5535 15.0003L18.8311 17.215Z",
    fill: "#174FA7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleAuthenticatorIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-authenticator-icon.acf708016e658c88bbaceeb71a276dfe.svg";